﻿export default function MobileStickyBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background-50 border-t border-background-200/70">
      <div className="flex items-center">
        <a
          href="https://wa.me/905539591940"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 bg-accent-500 text-background-50 py-3 text-sm font-medium"
        >
          <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
          WhatsApp
        </a>
        <a
          href="tel:05539591940"
          className="flex-1 flex items-center justify-center gap-2 bg-primary-500 text-background-50 py-3 text-sm font-medium"
        >
          <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
          Hemen Ara
        </a>
        <a
          href="/iletisim"
          className="flex-1 flex items-center justify-center gap-2 bg-secondary-500 text-background-50 py-3 text-sm font-medium"
        >
          <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center"></i>
          Adres
        </a>
      </div>
    </div>
  );
}
